var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Progress type="line"
 * @author zhuwanying02
 */
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { classPrefix } from '../../common/util';

// width        可选，设置宽度
// status       可选，'normal'，'success'，'error'
// percent      必填，取值在0-100之间，大于100时取100，小于0时取0
// formatText   可自定义text内容，默认显示百分比
// className    可选，在根元素上添加类
// style        可选，在根元素上添加样式
// classPrefix  可选，类前缀

var LineProgress = function (_PureComponent) {
    _inherits(LineProgress, _PureComponent);

    function LineProgress() {
        _classCallCheck(this, LineProgress);

        return _possibleConstructorReturn(this, (LineProgress.__proto__ || Object.getPrototypeOf(LineProgress)).apply(this, arguments));
    }

    _createClass(LineProgress, [{
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props = this.props,
                classPrefix = _props.classPrefix,
                className = _props.className,
                style = _props.style,
                width = _props.width,
                status = _props.status,
                percent = _props.percent,
                formatText = _props.formatText;

            var validatedPercent = percent > 100 ? 100 : percent < 0 ? 0 : percent;
            // 当百分比为100%时，自动将状态值设置为sucess
            var skin = percent === 100 ? 'success' : status;
            var prefixCls = classPrefix + '-line-progress';
            var rootClass = classnames((_classnames = {}, _defineProperty(_classnames, prefixCls, true), _defineProperty(_classnames, className, !!className), _classnames));
            var progressLineStyle = { width: width };
            var progressInnerClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, prefixCls + '-inner', true), _defineProperty(_classnames2, prefixCls + '-inner-' + skin, true), _classnames2));
            // 百分比系数
            var co = validatedPercent * 1.0 / 100;
            var progressInnerStyle = { width: co * width };
            var iconClass = classnames(_defineProperty({
                'line-icon': true
            }, 'line-icon-' + skin, true));

            // 格式化显示text
            var text = percent + '%';
            if (formatText) {
                text = formatText(percent);
            }
            return React.createElement(
                'div',
                { className: rootClass, style: style },
                React.createElement(
                    'div',
                    { className: prefixCls + '-outer', style: progressLineStyle },
                    React.createElement('div', { className: progressInnerClass, style: progressInnerStyle })
                ),
                React.createElement(
                    'span',
                    { className: prefixCls + '-text-line' },
                    percent === 100 || skin === 'error' ? React.createElement('i', { className: iconClass }) : text
                )
            );
        }
    }]);

    return LineProgress;
}(PureComponent);

LineProgress.defaultProps = {
    classPrefix: classPrefix,
    width: 320
};
LineProgress.propTypes = {
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    status: PropTypes.oneOf(['normal', 'success', 'error']),
    percent: PropTypes.number,
    formatText: PropTypes.func
};
export default LineProgress;